export const MAIN_API = process.env.REACT_APP_API_URL;
// Permite sobreescribir solo los endpoints de pago por un proxy (p.ej. Vercel)
export const PAYMENT_API = process.env.REACT_APP_PAYMENT_API || MAIN_API;
// Permite sobreescribir el host del redirect (HTML que auto-postea a Fiserv)
export const PAYMENT_REDIRECT_BASE = process.env.REACT_APP_PAYMENT_REDIRECT_BASE || MAIN_API;

/* ---------------------------- ALL category API ---------------------------- */
export const GET_CATEGORY_API = "/api/app/category/getcategory";
/* ---------------------------- END category API ---------------------------- */
/* ---------------------------- ALL state API ---------------------------- */
export const GET_STATE_API = "/api/app/state/getstate";
/* ---------------------------- END state API ---------------------------- */

/* ---------------------------- ALL city API ---------------------------- */
export const GET_CITY_API = "/api/app/city/getcity";
export const GET_CITY_BY_STATE_ID_API = "/api/app/city/getcitybystateid";
/* ---------------------------- END city API ---------------------------- */
/* ---------------------------- ALL venue API ---------------------------- */
export const GET_VENUE_API = "/api/app/venue/getvenue";
export const GET_VENUE_BY_CITY_ID_API = "/api/app/venue/getvenuebycityid";
/* ---------------------------- END venue API ---------------------------- */
/* ---------------------------- ALL event API ---------------------------- */
export const GET_FEATURED_EVENT_API = "/api/app/event/featuredevent";
export const GET_COUNT_API = "/api/app/event/counts";
export const GET_SEARCH_EVENT_API = "/api/app/event/allEvent?page=";
export const GET_EVENT_BY_ID_API = "/api/app/event/event/";
export const GET_SESSION_BY_DAY_ID_API = "/api/app/event/getshedule";
export const GET_SEARCH_SUGGESTION_API = "/api/app/event/serceSuggetion";
export const GET_EVENT_SPONSOR_API = "/api/app/event/getsponsor";
export const GET_PREVIEW_EVENT_API = (token) => `/preview/${token}`;
export const GET_PREVIEW_STATUS_API = (token) => `/preview/${token}/status`;
export const GET_ALL_BARS_API = "/api/app/bar/allBar";
export const GET_BAR_BY_ID_API = (id) => `/api/app/bar/${id}`;
export const GET_BAR_AVAILABILITY_API = (id, date) =>
  `/api/app/bar/${id}/availability?date=${encodeURIComponent(date)}`;
export const HOLD_RESERVATION_API = "/api/app/reservation/hold";
export const CREATE_RESERVATION_API = "/api/app/reservation";
export const GET_RESERVATION_STATUS_API = (barId, code) => `/api/app/reservation/${barId}/${code}/status`;
export const GET_MY_RESERVATIONS_API = "/api/app/reservation/mine";
/* ---------------------------- END event API ---------------------------- */
/* ---------------------------- ALL club (canchas) API ---------------------------- */
export const GET_ALL_CLUBS_API = "/api/app/club";
export const GET_CLUB_BY_ID_API = (id) => `/api/app/club/${id}`;
export const GET_CLUB_AVAILABILITY_API = (id) => `/api/app/club/${id}/availability`;
export const GET_CLUB_PRICE_API = (id) => `/api/app/club/${id}/price`;
export const HOLD_CLUB_RESERVATION_API = "/api/app/club/reservation/hold";
export const CREATE_CLUB_RESERVATION_API = "/api/app/club/reservation";
// Cumpleaños (público): disponibilidad por paquete, reserva directa, pedido por aprobación y link de pago por token.
export const GET_CLUB_BIRTHDAY_AVAILABILITY_API = (id) => `/api/app/club/${id}/birthdays/availability`;
export const CREATE_CLUB_BIRTHDAY_RESERVATION_API = (id) => `/api/app/club/${id}/birthdays/reservation`;
export const CREATE_CLUB_BIRTHDAY_REQUEST_API = (id) => `/api/app/club/${id}/birthdays/requests`;
export const GET_BIRTHDAY_REQUEST_API = (token) => `/api/app/birthdays/requests/${token}`;
export const PAY_BIRTHDAY_REQUEST_API = (token) => `/api/app/birthdays/requests/${token}/pay`;
// Partidos abiertos ("Falta un jugador"): listado público entre clubes, con los mismos filtros del listado de clubes.
export const GET_OPEN_MATCHES_API = "/api/app/open-matches";
export const CREATE_OPEN_MATCH_API = "/api/app/open-matches";
// Detalle por id, por token de "compartir" (link público) y alta de un jugador en el partido.
export const GET_MY_OPEN_MATCHES_API = "/api/app/open-matches/mine";
export const GET_OPEN_MATCH_API = (id) => `/api/app/open-matches/${id}`;
export const GET_OPEN_MATCH_BY_SHARE_API = (shareToken) => `/api/app/open-matches/share/${shareToken}`;
export const JOIN_OPEN_MATCH_API = (id) => `/api/app/open-matches/${id}/join`;
// Vista del jugador del link de gestión (T11): /me, /leave y /cancel; el token va en el header x-manage-token.
export const OPEN_MATCH_ME_API = (id) => `/api/app/open-matches/${id}/me`;
export const LEAVE_OPEN_MATCH_API = (id) => `/api/app/open-matches/${id}/leave`;
export const CANCEL_OPEN_MATCH_API = (id) => `/api/app/open-matches/${id}/cancel`;
/* ---------------------------- END club (canchas) API ---------------------------- */
/* ---------------------------- ALL beauty (turnos) API ---------------------------- */
export const GET_BEAUTY_SALONS_API = "/api/app/beauty/salons";
export const GET_BEAUTY_SALON_API = (slugOrId) => `/api/app/beauty/salon/${slugOrId}`;
export const GET_BEAUTY_AVAILABILITY_API = "/api/app/beauty/availability";
export const HOLD_BEAUTY_APPOINTMENT_API = "/api/app/beauty/hold";
export const CREATE_BEAUTY_RESERVATION_API = "/api/app/beauty/reservation";
/* ---------------------------- END beauty (turnos) API ---------------------------- */
/* ---------------------------- ALL venue reviews API ---------------------------- */
export const CREATE_VENUE_REVIEW_API = "/api/app/reviews";
export const GET_VENUE_REVIEWS_API = (barId) => `/api/app/reviews/venue/${barId}`;
/* ---------------------------- END venue reviews API ---------------------------- */
/* ---------------------------- ALL blog API ---------------------------- */
export const GET_LATEST_BLOG_API = "/api/app/blog/getlatestblog";
export const GET_BLOG_BY_ID_API = "/api/app/blog/getblogbyid";
export const GET_ALL_BLOG_API = "/api/app/blog/getallblog?page=";
/* ---------------------------- END blog API ---------------------------- */
/* ---------------------------- ALL sponser API ---------------------------- */
export const GET_SPONSOR_API = "/api/app/sponser/getsponser";
/* ---------------------------- END sponser API ---------------------------- */
/* ---------------------------- ALL auth API ---------------------------- */
export const REGISTER_API = "/api/app/user/register";
export const VERIFY_EMAIL_API = "/api/app/user/verifyemail";
export const LOGIN_API = "/api/app/user/login";
// El pase desde Zoco (back: routes/zoco.routes.js). Anónimos: el canje se autentica con el
// código, renovar y salir con el refresh.
export const ZOCO_CANJEAR_API = "/api/zoco/canjear";
export const ZOCO_REFRESCAR_API = "/api/zoco/refrescar";
export const ZOCO_SALIR_API = "/api/zoco/salir";
export const GOOGLE_USER_INFO_API = "https://www.googleapis.com/oauth2/v3/userinfo";
export const SOCIAL_LOGIN_API = "/api/app/user/socialLogin";
export const CHECK_EMAIL_API = "/api/app/user/checkemail";
export const VERIFY_OTP_API = "/api/app/user/verifyotp";
export const FORGOT_PASSWORD_API = "/api/app/user/forgotpassword";
export const GET_POPUP_IMAGE_API = "/api/app/user/popupimage";
// User profile
export const UPDATE_PROFILE_API = "/api/app/user/updateprofile";
// Change password (logged user)
export const CHANGE_PASSWORD_API = "/api/app/user/changepassword";
// Delete account (logged user)
export const DELETE_ACCOUNT_API = "/api/app/user/deleteaccount";
/* ---------------------------- END auth API ---------------------------- */
/* ---------------------------- ALL appSettings API ---------------------------- */
export const GET_APP_SETTINGS_API = "/api/app/user/getappsetting";
/* ---------------------------- END appSettings API ---------------------------- */

/* ---------------------------- ALL contact API ---------------------------- */
export const SEND_MESSAGE_API = "/api/app/contectus/sendmessage";
export const SUBMIT_REGRET_API = "/api/app/regret/submit";
/* ---------------------------- END contact API ---------------------------- */

/* ---------------------------- ORGANIZER API ---------------------------- */
// Events
export const ORG_LIST_EVENTS_API = "/api/organizer/events/all";
export const ORG_ADD_EVENT_API = "/api/organizer/events/add";
export const ORG_UPDATE_EVENT_API = "/api/organizer/events/update";
export const ORG_DELETE_EVENT_API = "/api/organizer/events/delete";

// Scanners
export const ORG_LIST_SCANNERS_API = "/api/organizer/scanners";
export const ORG_CREATE_SCANNER_API = "/api/organizer/scanners";
export const ORG_DELETE_SCANNER_API = (id) => `/api/organizer/scanners/${id}`;
export const ORG_ASSIGN_SCANNER_API = "/api/organizer/scanners/assign";
export const ORG_UNASSIGN_SCANNER_API = "/api/organizer/scanners/unassign";

// Organizer profile
export const ORG_ME_API = "/api/organizer/me";
export const ORG_PAYMENTS_API = "/api/organizer/me";

// Orders
export const ORG_ORDERS_API = "/api/organizer/orders"; // GET
export const ORG_ORDERS_INCOME_API = "/api/organizer/orders/income"; // GET

// Coupons
export const ORG_COUPONS_CREATE_API = "/api/organizer/coupons/create";
export const ORG_COUPONS_ALL_API = "/api/organizer/coupons/all"; // GET
export const ORG_COUPONS_UPDATE_API = "/api/organizer/coupons/update";

// Club statistics (canchas): GET, query { from, to, sport?, courtId? }
export const ORG_CLUB_STATS_API = (clubId) => `/api/organizer/clubs/${clubId}/stats`;

// Beauty statistics (salón): GET, query { from, to, professionalId?, salonId? }
export const ORG_BEAUTY_STATS_API = "/api/organizer/beauty/stats";

// Event Sponsors
export const ORG_SPONSORS_ADD_API = "/api/organizer/eventsponsor/addeventsponsor";
export const ORG_SPONSORS_UPDATE_API = "/api/organizer/eventsponsor/updateeventsponsor";
export const ORG_SPONSORS_ALL_API = "/api/organizer/eventsponsor/alleventsponsor"; // GET
export const ORG_SPONSORS_DELETE_API = "/api/organizer/eventsponsor/deleteeventsponsor";
export const ORG_SPONSORS_BY_EVENT_API = "/api/organizer/eventsponsor/geteventsponsorbyeventid";

// Reports
export const ORG_REPORTS_DAYWISEINCOME_API = "/api/organizer/reports/daywiseincome"; // GET
export const ORG_REPORTS_TOTALS_API = "/api/organizer/reports/totals"; // GET
/* ---------------------------- END ORGANIZER API ---------------------------- */
/* ---------------------------- ALL cart API ---------------------------- */
export const GET_CART_API = "/api/app/cart/getcart";
export const ADD_CART_API = "/api/app/cart/addtocart";
export const REMOVE_CART_API = "/api/app/cart/removefromcart";
export const UPDATE_CART_API = "/api/app/cart/updatecart";
/* ---------------------------- END cart API ---------------------------- */
/* ---------------------------- ALL discount API ---------------------------- */
export const APPLY_DISCOUNT_API = "/api/app/cart/applycuponcode";
export const GET_DISCOUNT_API = "/api/app/cart/getcuponcode";
/* ---------------------------- END discount API ---------------------------- */
/* ---------------------------- ALL order API ---------------------------- */
export const CHECKOUT_API = "/api/app/order/createorder";
export const VERIFY_PAYMENT_API = "/api/app/orders/successpayment";
export const GET_ORDER_API = "/api/app/order/getorders";
export const POST_REVIEW_API = "/api/app/order/addrating";
export const GET_ORDER_BY_ID_API = "/api/app/order/getorderbyid";
// User Event History
export const GET_MY_EVENTS_API = "/api/app/order/myevents"; // GET
export const GET_MY_EVENT_DETAIL_API = (id) => `/api/app/order/myevents/${id}`; // GET
/* ---------------------------- END order API ---------------------------- */

/* ---------------------------- TICKET TRANSFER ---------------------------- */
// Accept a pending transfer by token (auth required)
export const ACCEPT_TICKET_TRANSFER_API = "/api/tickets/transfer/accept";
export const INITIATE_TICKET_TRANSFER_API = (ticketId) => `/api/tickets/${ticketId}/transfer/initiate`;
/* ---------------------------- END TICKET TRANSFER ---------------------------- */

/* ---------------------------- ALL Banner API ---------------------------- */
export const ADD_BANNER_API = '/api/admin/banners'
export const GET_ALL_BANNER_API = '/api/admin/banners'
export const GET_BANNER_BY_ID_API = (id) => `/api/admin/banners/${id}`
export const UPDATE_BANNER_API = (id) => `/api/admin/banners/${id}`
export const REORDER_BANNER_IMAGES_API = (id) => `/api/admin/banners/${id}/reorder`
export const DELETE_BANNER_API = (id) => `/api/admin/banners/${id}`

// 👇 endpoint público por code
export const GET_ACTIVE_BANNERS_API = '/api/app/banners'
export const GET_ACTIVE_BANNER_BY_CODE_API = (code) => `/api/app/banners/${code}`
/* ---------------------------- END Banner API ---------------------------- */
